import { useEffect, useState } from 'react';

/** Epoch ms of a server start time; null when absent or unreadable. */
export const startedAtMs = (startedAt?: string | number | null): number | null => {
  if (startedAt === null || startedAt === undefined || startedAt === '') return null;
  const ms = typeof startedAt === 'number' ? startedAt : new Date(startedAt).getTime();
  return Number.isFinite(ms) ? ms : null;
};

/**
 * True once a wait has run past the top of its usual range. The overlay then
 * says "Taking a bit longer — still working" instead of the range — never a
 * clock, so the buyer gets one calm change of copy rather than a counter to
 * watch. Counted from `startedAt` (the server's run marker) when there is one,
 * so a reload picks up where the run really is; otherwise from when the wait
 * began on this screen. Resets the moment the wait ends.
 */
export const useLongWait = (
  active: boolean,
  afterMs: number,
  startedAt?: string | number | null,
): boolean => {
  const [long, setLong] = useState(false);
  const since = startedAtMs(startedAt);
  useEffect(() => {
    setLong(false);
    if (!active) return undefined;
    const untilLong = since === null ? afterMs : Math.max(0, since + afterMs - Date.now());
    if (untilLong === 0) {
      setLong(true);
      return undefined;
    }
    const timer = window.setTimeout(() => setLong(true), untilLong);
    return () => window.clearTimeout(timer);
  }, [active, afterMs, since]);
  return active && long;
};

export default useLongWait;
